import React from 'react';
import './library.css'; // Ensure the correct path

function DigitalLibrary() {
  return (
    <div className="button-digital-library">
      <a href="https://digitallibrary.eyecareinstitute.lk" className="fixed-button" target="_blank" rel="noopener noreferrer">
        Visit Digital Library
      </a>
    </div>
  );
}

export default DigitalLibrary;
